import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-hold-dialog',
  templateUrl: './hold-dialog.component.html',
  styleUrls: ['./hold-dialog.component.scss']
})
export class HoldDialogComponent implements OnInit {

  public reason:string = "";

  constructor(private modal: NgbActiveModal) { }

  ngOnInit() {
  }

  public close(holdType?:'merchant'| 'terminal'| 'single') {
    this.modal.close({
      holdType: holdType,
      reason: this.reason
    });
  }


}
